<template>
  <q-card flat :style="$q.screen.lt.md?'':'min-width: 500px'">
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span>نوع چاپ را انتخاب کنید</span>
        <template v-slot:action>
          <q-btn icon="close" flat round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-select v-model="selectedPrintForm"
                :options="printList"
                option-value="id"
                option-label="Caption"
                filled
                label="نوع گزارش خود را انتخاب کنید"
      />
    </q-card-section>
    <q-card-actions align="left">
      <q-btn label="تایید" @click="loadReport" icon="done" color="primary"/>
      <q-btn label="انصراف" v-close-popup icon="cancel" color="red" flat class="q-ml-sm"/>
    </q-card-actions>
  </q-card>
</template>

<script>
export default {
  name: 'OrderPrintDialog',
  components: {},
  props: {
    title: {
      type: String,
      required: true,
      default: () => 'گزارش'
    },
    orderInfo: {
      type: Object,
      default: () => {
      }
    },
    customerCode: {
      type: Number,
      default: () => undefined
    }
  },
  data() {
    return {
      selectedPrintForm: undefined,
      printList: [
        {id: 1, Caption: 'چاپ سفارش به همراه سربرگ', CompanyHeader: true},
        {id: 2, Caption: 'چاپ سفارش بدون سربرگ', CompanyHeader: false},
        {id: 3, Caption: 'چاپ حواله', CompanyHeader: false}
      ]
    }
  },
  methods: {
    async loadReport() {
      if (this.selectedPrintForm) {
        if (this.selectedPrintForm.id === 3) {
          await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات انبار/حواله خروج و برگشتی?rs:Format=PDF&SaleNum=${this.orderInfo.Sale_Num}&SaleKind=${1}&StoreID=${-1}&rc:Parameters=False&rc:Zoom=Page Width`)
        } else {
          await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/فاکتورهای فروش/سفارش فروش?rs:Format=PDF&SaleNum=${this.orderInfo.Order_Num?this.orderInfo.Order_Num:this.orderInfo.Sale_Num}&SaleKind=${this.orderInfo.Sale_Kind}&CompanyHeader=${this.selectedPrintForm.CompanyHeader}&rc:Parameters=False&rc:Zoom=Page Width`)
        }
      } else {
        this.$q.notify(
            {
              type: 'negative',
              color: 'negative',
              position: 'top',
              message: 'نوع گزارش را انتخاب نمایید'
            })
      }
    }
  },
  created() {
    if (this.orderInfo.Hava_Num === null) {
      this.printList.length = this.printList.length - 1
    }
  }
}
</script>